import { Button } from "../../ui/Button.jsx";
import { HeaderLink } from "../../ui/HeaderLink.jsx";
import { Dropdown } from "../../ui/Dropdown.jsx";
import { Logo } from "../../ui/Logo.jsx";
import { FancyButton } from "../../FancyButton/FancyButton";
import { LocationIcon } from "../../ui/Icons.jsx";
import { ExternalIcon } from "../../ui/Icons.jsx";
import { Link } from "react-router-dom";
import { iconMap } from "../../ui/Icons.jsx"; // Agregar esta importación

export const DesktopHeader = ({
  showLogo,
  locationButton,
  navigation,
  ctaButton,
  dropdownStates,
  toggleDropdown,
  handleExperienciasItemClick,
}) => {
  return (
    <>
      {/* Left Section: Logo + Location */}
      <div className="header-left flex flex-col lg:flex-col items-start lg:items-center gap-2 lg:gap-4 flex-1 lg:flex-none">
        {/* Logo */}
        {showLogo && (
          <Link to="/" className="header-logo flex-shrink-0">
            <Logo
              className="w-[110px] h-auto max-w-[120px] sm:max-w-[140px] md:max-w-[160px] lg:max-w-[180px]"
              style={{
                transform: "scale(1.2)",
                transformOrigin: "left center",
              }}
            />
          </Link>
        )}

        {/* Location Button - Solo visible en desktop dentro del header */}
        {locationButton.show && (
          <div className="hidden lg:block">
            <FancyButton
              children={locationButton.text}
              appearance="3d"
              variant="text"
              startIcon={<LocationIcon />}
              size="small"
            ></FancyButton>
          </div>
        )}
      </div>

      {/* Center Section: Navigation (Desktop Only) */}
      <nav className="header-nav hidden lg:flex items-center gap-4 flex-1 justify-center overflow-visible">
        {/* Navegación dinámica desde configuración */}
        {navigation.map((item, index) => {
          // Caso especial para EXPERIENCIAS con dropdown
          if (item.label === "EXPERIENCIAS" && item.experienciasDropdown) {
            return (
              <div key={index} onClick={(e) => e.stopPropagation()}>
                <Dropdown
                  trigger={
                    <HeaderLink
                      hasDropdown={true}
                      isOpen={dropdownStates.experiencias}
                      onClick={toggleDropdown}
                    >
                      EXPERIENCIAS
                    </HeaderLink>
                  }
                  items={item.experienciasDropdown.items.map(
                    (dropdownItem) => ({
                      ...dropdownItem,
                      onClick: () => handleExperienciasItemClick(dropdownItem),
                    })
                  )}
                  isOpen={dropdownStates.experiencias}
                  onToggle={() => toggleDropdown("experiencias")}
                  position="bottom-left"
                />
              </div>
            );
          }

          // Navegación regular
          const hasDropdown = item.dropdown && item.dropdown.length > 0;

          return (
            <div key={index} className="relative">
              {item.href ? (
                <HeaderLink
                  key={index}
                  href={item.href}
                  external={item.external}
                  icon={item.icon || (item.external ? "ExternalIcon" : undefined)}
                  className="text-white hover:text-accent-400 transition-colors duration-200 font-sweet text-sm font-medium"
                >
                  {item.label}
                </HeaderLink>
              ) : hasDropdown ? (
                <HeaderLink
                  hasDropdown={true}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleDropdown("general", index);
                  }}
                >
                  {item.label}
                </HeaderLink>
              ) : (
                <HeaderLink>{item.label}</HeaderLink>
              )}
            </div>
          );
        })}
      </nav>

      {/* Right Section: CTA */}
      <div className="header-right items-center">
        {/* CTA Button - Solo Desktop */}
        {ctaButton.show && (
          <div className="hidden lg:block">
            <FancyButton
              children={ctaButton.text}
              appearance="classic"
              variant="outline"
              borderColor="#00b3e6"
              size="small"
            ></FancyButton>
          </div>
        )}
      </div>
    </>
  );
};

// Función auxiliar: renderiza iconos por nombre usando el iconMap
// Acepta nombres definidos en src/components/ui/Icons.jsx (por ejemplo "ExternalIcon", "LocationIcon", etc.)
const renderIcon = (iconName) => {
  if (!iconName) return null;
  const Icon = iconMap?.[iconName];
  if (!Icon) return null;
  return <Icon className="w-4 h-4" />;
};

export const Desktop = ({ locationButton, navigation, ctaButton }) => {
  return (
    <>
      {/* Left Section: Logo + Location */}
      <div className="header-left flex flex-col lg:flex-col items-start lg:items-center gap-2 lg:gap-4 flex-1 lg:flex-none">
        {/* Logo */}
        {showLogo && (
          <Link to="/" className="header-logo flex-shrink-0">
            <Logo
              className="w-[110px] h-auto max-w-[120px] sm:max-w-[140px] md:max-w-[160px] lg:max-w-[180px]"
              style={{
                transform: "scale(1.2)",
                transformOrigin: "left center",
              }}
            />
          </Link>
        )}

        {/* Location Button - Solo visible en desktop dentro del header */}
        {locationButton.show && (
          <div className="hidden lg:block">
            <FancyButton
              children={locationButton.text}
              appearance="3d"
              variant="text"
              startIcon={<LocationIcon />}
              size="small"
            ></FancyButton>
          </div>
        )}
      </div>

      {/* Center Section: Navigation (Desktop Only) */}
      <nav className="header-nav hidden lg:flex items-center gap-4 flex-1 justify-center overflow-visible">
        {/* Navegación dinámica desde configuración */}
        {navigation.map((item, index) => {
          // Caso especial para EXPERIENCIAS con dropdown
          if (item.label === "EXPERIENCIAS" && item.experienciasDropdown) {
            return (
              <div key={index} onClick={(e) => e.stopPropagation()}>
                <Dropdown
                  trigger={
                    <HeaderLink
                      hasDropdown={true}
                      isOpen={dropdownStates.experiencias}
                      onClick={toggleDropdown}
                    >
                      EXPERIENCIAS
                    </HeaderLink>
                  }
                  items={item.experienciasDropdown.items.map(
                    (dropdownItem) => ({
                      ...dropdownItem,
                      onClick: () => handleExperienciasItemClick(dropdownItem),
                    })
                  )}
                  isOpen={dropdownStates.experiencias}
                  onToggle={() => toggleDropdown("experiencias")}
                  position="bottom-left"
                />
              </div>
            );
          }

          // Navegación regular
          const hasDropdown = item.dropdown && item.dropdown.length > 0;

          return (
            <div key={index} className="relative">
              {item.href ? (
                <HeaderLink
                  key={index}
                  href={item.href}
                  external={item.external}
                  icon={item.icon || (item.external ? "ExternalIcon" : undefined)}
                  className="text-white hover:text-accent-400 transition-colors duration-200 font-sweet text-sm font-medium"
                >
                  {item.label}
                </HeaderLink>
              ) : hasDropdown ? (
                <HeaderLink
                  hasDropdown={true}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleDropdown("general", index);
                  }}
                >
                  {item.label}
                </HeaderLink>
              ) : (
                <HeaderLink>{item.label}</HeaderLink>
              )}
            </div>
          );
        })}
      </nav>

      {/* Right Section: CTA */}
      <div className="header-right items-center">
        {/* CTA Button - Solo Desktop */}
        {ctaButton.show && (
          <div className="hidden lg:block">
            <FancyButton
              children={ctaButton.text}
              appearance="classic"
              variant="outline"
              borderColor="#00b3e6"
              size="small"
            ></FancyButton>
          </div>
        )}
      </div>
    </>
  );
};
